import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";
import { CheckLg } from "react-bootstrap-icons";
import axios from "axios";

class JourneyPlannerStore {
  journeys = [];
  total = 0;
  loading = false;
  safetymanagerlist = [];
  stafflist = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      journeys: observable,
      total: observable,
      loading: observable,
      safetymanagerlist: observable,
      stafflist: observable,
      loadData: action,
      addData: action,
      getJourneyData: action,
      deleteRecord: action,
      getJourneyManager: action,
      getjourneyDesk: action,
      getVehicleLog: action,
      updateExtendedDateTime: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, searchField, isadmin, applicantNo, travelType, userId }) {
    this.loading = true;
    try {
      const postData = { companyId, offset, limit, searchField, isadmin, applicantNo, travelType, userId };
      const response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/journeyplanner/getJourneyPlannerList", postData);

      const responseData = response?.data?.data;

      if (responseData) {
        this.journeys = responseData?.journeyplannerdetails || [];
        this.total = parseInt(responseData?.TotalCount) || 0;
      } else {
        this.journeys = [];
        this.total = 0;
      }
    } catch (error) {
      console.error("Error loading journey planner list data:", error);
      this.journeys = [];
      this.total = 0;
    } finally {
      this.loading = false;
    }
  }

  async addData(journey) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/journeyplanner/journeyplannersave", journey);
    return response;
  }

  async getJourneyData(journeyId) {
    console.log("journeyId>>>>>>>>>>>", journeyId);
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/journeyplanner/getJourneyPlannerList",
        { Id: journeyId }
      );
    console.log("response>>>>>>>>>>>", response);
    return response.data?.data?.journeyplannerdetails?.[0];
  }

  async deleteRecord(Id) {
    // const postData={
    //   Id:journeyId
    // }
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/journeyplanner/delete", Id);
    return response;
  }

  async getVehicleLog(Id) {
    const postData = {
      id: Id
    }
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/journeyplanner/getVehicleLog", postData);
    return response;
  }

  async getVehicles(companyId) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/journeyplanner/getVehicles", { companyId });
    return response.data?.data || [];
  }

  async updateExtendedDateTime(payload) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl +"/journeyplanner/updateExtendedDateTime", payload);
    return response;
  }


  async getJourneyManager(companyId) {
    const response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/journeyplanner/getJourneyManager", {
        companyId,
      });
    this.stafflist = response.data?.data?.staffList || [];
    this.safetymanagerlist = response.data?.data?.safetyManagerList || [];
    return response.data?.data?.journeyManagerList || [];
  }

  async getjourneyDesk() {
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl +"/journeyplanner/getjourneyDesk");
    return response.data?.data || [];
  }

  async closeJourney(postdata) {
    try {
      console.log(postdata, "record1111")
      const response = await postApi
        .getClient("")
        .post(config.NodeUrl +"/journeyplanner/closeJourney", postdata);
      return response;
    } catch (error) {
      console.error("closeJourney error:", error);
    }
  };

  async exportVehicleLogExcel(postdata) {
        const response = await axios.post(
          config.NodeUrl + "/journeyplanner/vehiclelogexcel",postdata,
          {
            
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.download = "Vehicle_Log.xlsx";
        document.body.appendChild(link);
        link.click();
        link.remove();
  }
}

export default JourneyPlannerStore;
